<app-table [data]="processTypes"
           [config]="tableConfig"
           [rowExpand]="false"
           [isLoading]="isLoading"
           [headerBackgroundColor]="headerBackgroundColor"
           [isMaterial]="false"
           [hasTitle]="hasTitle"
           title="{{'admin.equipment.processTypes.table.title' | translate}}"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)"
           (rowClick)="onRowClick($event)">
    <app-table-column header="{{'admin.equipment.processTypes.table.columns.id' | translate}}"
                      field="id">
    </app-table-column>
    <app-table-column header="{{'admin.equipment.processTypes.table.columns.name' | translate}}"
                      filterPlaceholder="{{'admin.equipment.processTypes.table.filter.placeholder.name' | translate}}"
                      filter="true"
                      sortable="true"
                      field="name">
    </app-table-column>
</app-table>
